module.exports = __webpack_public_path__ + "2f000646f5e63c819998eadf1407b51e.png";